export default function formatDate(isoDate: string): string {
  const date: Date = new Date(isoDate);

  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
   
  };

  return date.toLocaleString("en-US", options);
}
